'use client';

import { FeatureFlagEntry } from '@api';
import { APIHelper } from '@helpers/api';
import { action, makeObservable, observable } from 'mobx';
import { Apis } from 'src/data-access/api-provider';

export class FeatureFlagsStore {
  featureFlags: Record<string, FeatureFlagEntry> = {};

  private pendingInitialization: Promise<void> | null = null;

  constructor() {
    makeObservable(this, {
      featureFlags: observable,
      setFeatureFlags: action.bound,
      initializeFeatureFlags: action.bound,
    });
  }

  setFeatureFlags(value: Record<string, FeatureFlagEntry>) {
    this.featureFlags = value;
  }

  async initializeFeatureFlags() {
    if (this.pendingInitialization) return this.pendingInitialization;

    const initialize = async () => {
      let apis: Apis;
      try {
        const config = await APIHelper.createApiConfiguration();
        apis = APIHelper.createApisFromConfig(config);
        const response = await apis?.api.apiFeatureFlagsList();
        this.setFeatureFlags(response.flags);
      } catch (error) {
        console.log(error);
      }
    };

    this.pendingInitialization = initialize().finally(() => {
      this.pendingInitialization = null;
    });

    return this.pendingInitialization;
  }
}

export const featureFlagsStore = new FeatureFlagsStore();
